import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import CoverImage from "../../../assets/images/profile/cover.jpg";
import PhoneInput from "react-phone-input-2";
import {
  GetEditICAIUserData,
  UpdateICAIUser,
} from "../../../services/apis/ICAIUsersApi";
import { Toaster } from "../../components/Toaster/Toster";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BtnLoader from "../../components/Loader/btnLoader";
import apis from "../../../services/apis";
import profileAvatar from "../../../assets/images/avatar2.jpg";
import { useSelector } from "react-redux";
import { CreatelogActivityApi } from "../../../services/apis/IpAddress";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";
import { UpdateNonICAIUserApi } from "../../../services/apis/NonICAIUsersApi";
import Swal from "sweetalert2";

import websiteImg from "../../../assets/images/social-icon/website.jpg"
import catalogueImg from "../../../assets/images/social-icon/catelog.jpg"
import emailImg from "../../../assets/images/social-icon/email.jpg"
import whatsAppImg from "../../../assets/images/social-icon/whatsapp.jpg"
import instagramImg from "../../../assets/images/social-icon/instagram.jpg"
import linkedinImg from "../../../assets/images/social-icon/linkedin.png"
import phoneImg from "../../../assets/images/social-icon/phone.jpg"
import youtubeImg from "../../../assets/images/social-icon/youtube.png"
import messageImg from "../../../assets/images/social-icon/message.jpg"
import kakaotalkImg from "../../../assets/images/social-icon/kakaotalk.jpg"
import skypeImg from "../../../assets/images/social-icon/skype.jpg"
import locationImg from "../../../assets/images/social-icon/location.jpg"
import wechatImg from "../../../assets/images/social-icon/wechat.jpg"
import calendyImg from "../../../assets/images/social-icon/calendly.jpg"
import twitchImg from "../../../assets/images/social-icon/twitch.jpg"
import telegramImg from "../../../assets/images/social-icon/telegram.jpg"
import snapchatImg from "../../../assets/images/social-icon/snapchat.jpg"
import ticktokImg from "../../../assets/images/social-icon/tiktok.jpg"
import pintrestImg from "../../../assets/images/social-icon/pintrest.jpg"
import twitterImg from "../../../assets/images/social-icon/twitter.jpg"
import facebookImg from "../../../assets/images/social-icon/facebook.png"
import trustpilotImg from "../../../assets/images/social-icon/trustpilot.jpg"
import tripadvisorImg from "../../../assets/images/social-icon/Tripadvisor.png"
import videoImg from "../../../assets/images/social-icon/video.jpg"
import imageImg from "../../../assets/images/social-icon/image.jpg"
import pdfImg from "../../../assets/images/social-icon/pdf.jpg"
import slackImg from "../../../assets/images/social-icon/slack.jpg"
import menuImg from "../../../assets/images/social-icon/menu.jpg"
import discordImg from "../../../assets/images/social-icon/discord.jpg"
import spotifyImg from "../../../assets/images/social-icon/spotify.jpg"
import paypalImg from "../../../assets/images/social-icon/paypal.jpg"
import playstoreImg from "../../../assets/images/social-icon/playstore.jpg"
import appstoreImg from "../../../assets/images/social-icon/appstore.jpg"
import mediumImg from "../../../assets/images/social-icon/medium.jpg"
import behanceImg from "../../../assets/images/social-icon/behance.jpg"
import amazonImg from "../../../assets/images/social-icon/amazon.jpg"
import flipkartImg from "../../../assets/images/social-icon/flipkart.jpg"
import myntraImg from "../../../assets/images/social-icon/myntra.jpg"
import bookingImg from "../../../assets/images/social-icon/booking.jpg"
import facetimeImg from "../../../assets/images/social-icon/facetime.jpg"
import goibiboImg from "../../../assets/images/social-icon/goibibo.jpg"
import googleRatingImg from "../../../assets/images/social-icon/google rating.jpg"
import humanitixImg from "../../../assets/images/social-icon/humanitix.jpg"
import makemytripImg from "../../../assets/images/social-icon/makemytrip.jpg"
import meetupImg from "../../../assets/images/social-icon/meetup.jpg"
import onlyfansImg from "../../../assets/images/social-icon/only fans.jpg"
import openseaImg from "../../../assets/images/social-icon/open sea.jpg"
import swiggyImg from "../../../assets/images/social-icon/swiggy.jpg"
import zomatoImg from "../../../assets/images/social-icon/zomato.jpg"
import ticketmasterImg from "../../../assets/images/social-icon/ticket master.jpg"
import ubereatsImg from "../../../assets/images/social-icon/uber eats.jpg"
import eatclubImg from "../../../assets/images/social-icon/eatclub.png"
import whatsAppbusinessImg from "../../../assets/images/social-icon/whatsApp bus.jpg"
import lumaImg from "../../../assets/images/social-icon/luma.jpg"
import sortmysceneImg from "../../../assets/images/social-icon/sortmyscene.png"
import paytminsiderImg from "../../../assets/images/social-icon/paytm insider.png"
import bookmyshowImg from "../../../assets/images/social-icon/BookMyShow.jpg"
import stripeImg from "../../../assets/images/social-icon/stripe.jpg"
import cryptowalletImg from "../../../assets/images/social-icon/crypto wallet.png"

import "../../../assets/css/socialmedia.css";

const inputBlog = [
  { label: "Name", value: "" },
  { label: "Email", value: "" },
  { label: "Specialty", value: "" },
  { label: "Skills", value: "" },
];

const options1 = [
  { value: "1", label: "Gendar" },
  { value: "2", label: "Male" },
  { value: "3", label: "Female" },
  { value: "4", label: "Other" },
];

const options2 = [
  { value: "WRO", label: "WRO" },
  { value: "SRO", label: "SRO" },
  { value: "ERO", label: "ERO" },
  { value: "CRO", label: "CRO" },
  { value: "NRO", label: "NRO" },
  { value: "FRO", label: "FRO" },
  { value: "DUP", label: "DUP" },
];

const EditUser = () => {
  const id = useParams()?.id;
  const user_type = useLocation()?.state;

  const navigate = useNavigate();
  const [zoneOption, setZoneOption] = useState(options2);
  const [selectedZoneOption, setSelectedZoneOption] = useState(null);
  const [btnLoading, setBtnLoading] = useState();
  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
        ? "Tablet"
        : isDesktop
          ? "Desktop"
          : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };
  const [formData, setFormData] = useState({
    profile_image: null,
    cover_image: null,
    user_type: user_type,
    member_name: "",
    email: "",
    mobile: "",
    member_id: "",
    company_name: "",
    whatsapp_number: "",
    whatsapp_business_number: "",
    designation: "",
    website: "",
    linkedin_link: "",
    youtube: "",
    instagram_link: "",
    facebook_link: "",
    skype_id: "",
    industry: "",
    google_address: "",
    city: "",
    telegram_link: "",
    twitter_link: "",
    snapchat_link: "",
    template_id: "56789",
    zone: "",
  });

  const [profileUrl, setProfileUrl] = useState(null);
  const [uploadProfileUrl, setUploadProfileUrl] = useState(null);
  const [coverImgUrl, setCoverImgUrl] = useState(null);
  const [uploadCoverImgUrl, setUploadCoverImgUrl] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const informationIp = useSelector((data) => data?.ipAddressReducers?.ipAddressData);
  const user = useSelector((data) => data?.userReducers?.user);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files[0]) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const getEditUserData = async () => {
    try {
      const res = await GetEditICAIUserData(id);
      const U_Data = res?.data?.data;
      if (!U_Data) {
        console.error("No data found in response:", res);
        return;
      }

      const manageSocial_links = JSON.parse(U_Data?.social_media_links)
      setRecommendedData(manageSocial_links?.recommended);
      setContactData(manageSocial_links?.contact);
      setBusinessInfoData(manageSocial_links?.businessInfo);
      setSocialMediaData(manageSocial_links?.socialMedia);
      setReviewsData(manageSocial_links?.reviews);
      setContentData(manageSocial_links?.content);
      setFoodData(manageSocial_links?.food);
      setCommunicationData(manageSocial_links?.communication);
      setMusicData(manageSocial_links?.music);
      setShoppingData(manageSocial_links?.shopping);
      setEventData(manageSocial_links?.event);
      setPaymentsData(manageSocial_links?.payments);
      setMoreData(manageSocial_links?.more);


      // Set individual state values for dependent components
      setProfileUrl(U_Data?.profile_image || "");
      setCoverImgUrl(U_Data?.cover_image || "");

      setSelectedZoneOption({
        value: U_Data?.zone || "",
        label: U_Data?.zone || "",
      });
      const updatedFormData = {
        ...U_Data, // Keep other fields intact
        mobile: U_Data?.mobile ? `+${U_Data.mobile.toString()}` : "", // Ensure the phone number starts with `+` and is a string
        whatsapp_business_number: U_Data?.whatsapp_business_number
          ? `+${U_Data?.whatsapp_business_number?.toString()}`
          : "",
        whatsapp_number: U_Data?.whatsapp_number
          ? `+${U_Data?.whatsapp_number?.toString()}`
          : "",
      };

      setFormData(updatedFormData);
    } catch (err) {
      console.error("Error in fetching user data:", err);
    }
  };
  useEffect(() => {
    // if(user_type == "ICAI"){}
    getEditUserData();
  }, []);

  const handlePhoneChange = (value, name) => {
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.user_type) {
      newErrors.user_type = "Please choose an ICAI preference.";
    }
    // if (!formData.template) {
    //   newErrors.template = "Please select a template.";
    // }
    // File validation (profile_image and cover_image)

    if (!formData.profile_image) {
      newErrors.profile_image = "Profile image is required.";
    }
    if (formData.profile_image && formData.profile_image.size > 1048576) {
      newErrors.profile_image = "The file is too large. Maximum size is 1MB.";
    }

    if (formData.cover_image && formData.cover_image.size > 1048576) {
      newErrors.cover_image = "The file is too large. Maximum size is 1MB.";
    }

    //  {
    //   if(formData.user_type !== "ICAI")
    //   if (!formData?.cover_image) {
    //     newErrors.cover_image = "Cover image is required.";
    //   } else if (!formData.cover_image.type.startsWith("image/")) {
    //     newErrors.cover_image = "Only image files are allowed.";
    //   }
    //  }

    if (!formData.member_name) newErrors.member_name = "Name is required.";

    if (formData?.user_type == "Non-ICAI") {
      if (!formData.email) {
        newErrors.email = "Email is required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Enter a valid email address.";
      }
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Phone number is required.";
    } else if (formData.mobile.trim().length < 13) {
      newErrors.mobile = "Phone number must be exactly 12 characters.";
    }

    if (formData?.user_type == "ICAI") {
      if (!formData.member_id) newErrors.member_id = "Member Id is required.";
    }

    if (formData?.user_type == "ICAI") {
      if (!formData.zone) newErrors.zone = "Zone is required.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      Toaster.error("Please fix the errors before submitting.");
      return false;
    }
    // Return true if no errors
    return Object.keys(newErrors).length == 0;
  };

  const loggedActivity = async () => {
    const data = {
      id: user?._id,
      ipAddress: informationIp?.query,
      lat: informationIp?.lat,
      long: informationIp?.lon,
      logType: "useredit",
      deviceType: JSON.stringify(deviceType),
      city: informationIp?.city,
      countryCode: informationIp?.countryCode,
      regionCode: informationIp?.region,
    };
    try {
      await CreatelogActivityApi(data);
    } catch (err) {
      console.log(err);
    }
  };

  const updateICAIUser = async () => {
    setBtnLoading(true);
    try {
      const res = await UpdateICAIUser(id, formData);
      if (res?.data?.success) {
        loggedActivity();
        Swal.fire({
          icon: "success",
          title: "User Updated Successful",
          text: res?.data?.message,
        });
        Toaster.success(res?.data?.message);
        navigate("/icai-user-list");
      }
    } catch (err) {
      // console.log("handleCreate", err);
      Toaster.error(err?.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  const updateNonICAIUser = async () => {
    setBtnLoading(true);


    const socialMediaLinks = {
      recommended: { ...recommendedData },
      contact: { ...contactData },
      businessInfo: { ...businessInfoData },
      socialMedia: { ...socialMediaData },
      reviews: { ...reviewsData },
      content: { ...contentData },
      food: { ...foodData },
      communication: { ...communicationData },
      music: { ...musicData },
      shopping: { ...shoppingData },
      event: { ...eventData },
      payments: { ...paymentsData },
      more: { ...moreData },
    };

    try {
      const res = await UpdateNonICAIUserApi(id, { ...formData, social_media_links: JSON.stringify(socialMediaLinks) });
      if (res?.data?.success) {
        loggedActivity();
        Swal.fire({
          icon: "success",
          title: "User Updated Successful",
          text: res?.data?.message,
        });
        Toaster.success(res?.data?.message);
        navigate("/non-icai-list");
      }
    } catch (err) {
      // console.log("handleCreate", err);
      Toaster.error(err?.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // console.log("Form submitted successfully", formData);
      if (formData?.user_type == "ICAI") {
        updateICAIUser();
      } else {
        updateNonICAIUser();
      }
    }
  };

  const handlePhoneNoChange = (value, country) => {
    const phoneNum = value?.slice(country?.dialCode?.length);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      mobile: phone,
    });
  };

  const handleWhatsappNoChange = (value, country) => {
    const phoneNum = value?.slice(country?.dialCode?.length);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      whatsapp_number: phone,
    });
  };

  const handleWhatsappBusinessNoChange = (value, country) => {
    const phoneNum = value?.slice(country?.dialCode?.length);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      whatsapp_business_number: phone,
    });
  };


  const handleBusinessPhoneChange = (value, country) => {
    const phoneNum = value?.slice(country?.dialCode?.length);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;

    setBusinessInfoData((prevData) => ({
      ...prevData,
      business_phone: {
        ...prevData['business_phone'],
        ['url']: phone,
      },
    }));
  };

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadProfileUrl(URL.createObjectURL(file)); // Generate a local URL for the uploaded image
      setFormData({ ...formData, profile_image: file });
    }
  };

  const handleCoverImgUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadCoverImgUrl(URL.createObjectURL(file)); // Generate a local URL for the uploaded image
      setFormData({ ...formData, cover_image: file });
    }
  };


  const [recommendedData, setRecommendedData] = useState({
    website: { name: "", url: "" },
    catalogue: { name: "", url: "" },
    email: { name: "", url: "" },
    whatsApp: { name: "", url: "" },
    phone: { name: "", url: "" },
    google_reviews: { name: "", url: "" },
    instagram: { name: "", url: "" },
    linkedin: { name: "", url: "" },
    youtube: { name: "", url: "" },
  });

  const handleRecommendedChange = (e, field, type) => {
    const { value } = e.target;
    setRecommendedData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value,
      },
    }));
  };

  const [contactData, setContactData] = useState({
    email: { name: "", url: "" },
    whatsapp: { name: "", url: "" },
    phone: { name: "", url: "" },
    message: { name: "", url: "" },
    facetime: { name: "", url: "" },
    wechat: { name: "", url: "" },
    skype: { name: "", url: "" },
    wa_business: { name: "", url: "" },
    kakaotalk: { name: "", url: "" },
  });


  const handleContactChange = (e, field, type) => {
    const { value } = e.target;
    setContactData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [businessInfoData, setBusinessInfoData] = useState({
    website: { name: "", url: "" },
    catalogue: { name: "", url: "" },
    location: { name: "", url: "" },
    message: { name: "", url: "" },
    business_phone: { name: "", url: "" },
    business_email: { name: "", url: "" },
    calendly: { name: "", url: "" },
  });

  const handlebusinessInfoChange = (e, field, type) => {
    const { value } = e.target;
    setBusinessInfoData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [socialMediaData, setSocialMediaData] = useState({
    tiktok: { name: "", url: "" },
    instagram: { name: "", url: "" },
    facebook: { name: "", url: "" },
    linkedin: { name: "", url: "" },
    snapchat: { name: "", url: "" },
    youtube: { name: "", url: "" },
    twitter: { name: "", url: "" },
    pinterest: { name: "", url: "" },
    twitch: { name: "", url: "" },
    telegram: { name: "", url: "" },
  });

  const handleSocialMediaChange = (e, field, type) => {
    const { value } = e.target;
    setSocialMediaData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [reviewsData, setReviewsData] = useState({
    google_reviews: { name: "", url: "" },
    trustpilot: { name: "", url: "" },
    booking: { name: "", url: "" },
    tripadvisor: { name: "", url: "" },
    make_my_trip: { name: "", url: "" },
    goibibo: { name: "", url: "" },
  });

  const handleReviewsChange = (e, field, type) => {
    const { value } = e.target;
    setReviewsData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [contentData, setContentData] = useState({
    pdf: { name: "", url: "" },
    video: { name: "", url: "" },
    image: { name: "", url: "" },
  });

  const handleContentChange = (e, field, type) => {
    const { value } = e.target;
    setContentData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [foodData, setFoodData] = useState({
    zomato: { name: "", url: "" },
    swiggy: { name: "", url: "" },
    uber_eats: { name: "", url: "" },
    eatclub: { name: "", url: "" },
    menu: { name: "", url: "" },
  });

  const handleFoodChange = (e, field, type) => {
    const { value } = e.target;
    setFoodData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [communicationData, setCommunicationData] = useState({
    slack: { name: "", url: "" },
    whatsapp_group: { name: "", url: "" },
    facebook_group: { name: "", url: "" },
  });

  const handleCommunicationChange = (e, field, type) => {
    const { value } = e.target;
    setCommunicationData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };


  const [musicData, setMusicData] = useState({
    spotify: { name: "", url: "" },
  });

  const handleMusicChange = (e, field, type) => {
    const { value } = e.target;
    setMusicData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [shoppingData, setShoppingData] = useState({
    amazon: { name: "", url: "" },
    flipkart: { name: "", url: "" },
    myntra: { name: "", url: "" },
  });

  const handleShoppingChange = (e, field, type) => {
    const { value } = e.target;
    setShoppingData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };


  const [eventData, setEventData] = useState({
    meetup: { name: "", url: "" },
    humanitix: { name: "", url: "" },
    ticketmaster: { name: "", url: "" },
    luma: { name: "", url: "" },
    sort_my_scene: { name: "", url: "" },
    paytm_insider: { name: "", url: "" },
    book_my_show: { name: "", url: "" },
  });

  const handleEventChange = (e, field, type) => {
    const { value } = e.target;
    setEventData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [paymentsData, setPaymentsData] = useState({
    stripe: { name: "", url: "" },
    paypal: { name: "", url: "" },
    crypto_wallet: { name: "", url: "" },
  });

  const handlePaymentsChange = (e, field, type) => {
    const { value } = e.target;
    setPaymentsData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  const [moreData, setMoreData] = useState({
    medium: { name: "", url: "" },
    app_store: { name: "", url: "" },
    play_store: { name: "", url: "" },
    discord: { name: "", url: "" },
    only_fans: { name: "", url: "" },
    behance: { name: "", url: "" },
    open_sea: { name: "", url: "" },
  });

  const handleMoreChange = (e, field, type) => {
    const { value } = e.target;
    setMoreData((prevData) => ({
      ...prevData,
      [field]: {
        ...prevData[field],
        [type]: value, // type can be 'name' or 'url'
      },
    }));
  };

  return (
    <>
      <ToastContainer />
      <PageTitle activeMenu="Add User" motherMenu={"Users"} />
      <form className="profile-form" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xl-12">
            <div className="clearfix">
              <div className="card card-bx profile-card author-profile mb-3">
                <div className="card-body">
                  <div className="py-3 px-2">
                    {formData?.user_type !== "ICAI" && (
                      <div className="position-relative">
                        <img
                          className="profile-cover-image"
                          src={
                            uploadCoverImgUrl
                              ? uploadCoverImgUrl
                              : coverImgUrl
                                ? `${apis?.baseurl.Baseimageurl}${coverImgUrl}`
                                : CoverImage
                          }
                          alt="cover image"
                        />
                        <div
                          className="upload-link"
                          title=""
                          data-toggle="tooltip"
                          data-placement="right"
                          data-original-title="update">
                          <input
                            type="file"
                            className="update-flie"
                            name="cover_image"
                            onChange={handleCoverImgUpload}
                          />
                          <i className="fa fa-camera cursor-pointer"></i>
                        </div>
                        {errors.cover_image && (
                          <span className="cover-image-error-text text-danger fs-12">
                            {errors.cover_image}
                          </span>
                        )}
                        {!errors.cover_image && (
                          <p style={{ textAlign: "left", fontWeight: '600' }}>Recommended Banner Sizes (860×400px / 1290×600px)</p>
                        )}
                      </div>
                    )}

                    <div className="author-profile">
                      <div className="author-media">
                        <img
                          className={
                            formData?.user_type == "ICAI"
                              ? "profle-user-image mt-0"
                              : "profle-user-image"
                          }
                          src={
                            uploadProfileUrl
                              ? uploadProfileUrl
                              : profileUrl
                                ? `${apis?.baseurl.Baseimageurl}${profileUrl}`
                                : profileAvatar
                          }
                          alt=""
                        />
                        <div
                          className="upload-link"
                          title=""
                          data-toggle="tooltip"
                          data-placement="right"
                          data-original-title="update">
                          <input
                            type="file"
                            className="update-flie"
                            name="profile_image"
                            onChange={handleProfileUpload}
                          />
                          <i className="fa fa-camera"></i>
                        </div>
                        {errors.profile_image && (
                          <span className="text-danger fs-12">
                            {errors.profile_image}
                          </span>
                        )}
                      </div>
                      <div className="text-muted fs-12 mt-2">
                        Maximum file size: 1MB. Only image files are allowed.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card profile-card card-bx">
              {/* <div className="card-header">
                <h6 className="card-title">Profile Info </h6>
              </div> */}
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-3 mb-3">
                    <label className="form-label">
                      Choose ICAI Preferences
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2">
                      <div className="d-flex align-items-center">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            name="user_type"
                            value="ICAI"
                            checked={formData?.user_type == "ICAI"}
                            onChange={handleChange}
                            className="form-check-input mt-0 me-1"
                          />
                          ICAI
                        </label>
                      </div>
                      <div className="radio">
                        <label className="form-check-label">
                          <input
                            type="radio"
                            name="user_type"
                            value="Non-ICAI"
                            checked={formData?.user_type == "Non-ICAI"}
                            onChange={handleChange}
                            className="form-check-input mt-0 me-1"
                          />
                          Non ICAI
                        </label>
                      </div>
                    </div>
                    {errors.user_type && (
                      <span className="text-danger fs-12">
                        {errors.user_type}
                      </span>
                    )}
                  </div>

                  {/* <div className="col-sm-6 col-md-4 mb-3">
                    <label className="form-label">
                      Select Template <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2">
                      <div className="d-flex align-items-center">
                      <Select 
                        value={selectedTemplateOption}
                        options={templateOption} 
                        onChange={(option) => {
                          setSelectedTemplateOption(option); 
                          setFormData({
                              ...formData,
                            template: option.value, // Update the form data with the selected category value
                          });
                        }}
                        className="custom-react-select"
                      />
                      </div>
                    </div>
                    {errors.template && (
                      <span className="text-danger fs-12">{errors.template}</span>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card profile-card card-bx ">
              <div className="card-header">
                <h6 className="card-title">Profile Info </h6>
                {formData?.user_type == "Non-ICAI" &&
                  <p className="m-0 p-0 text-danger ">Primary Member Id : ({formData?.member_id})</p>
                }
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 col-md-4 mb-3">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="member_name"
                      value={formData?.member_name}
                      onChange={handleChange}
                    />
                    {errors.member_name && (
                      <span className="text-danger fs-12">
                        {errors.member_name}
                      </span>
                    )}
                  </div>

                  {
                    formData?.user_type == "ICAI" ?
                      <div className="col-sm-6 col-md-4 mb-3">
                        <label className="form-label">
                          Member Id <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          name="member_id"
                          value={formData?.member_id}
                          onChange={handleChange}
                        />
                        {errors.member_id && (
                          <span className="text-danger fs-12">
                            {errors.member_id}
                          </span>
                        )}
                      </div>
                      :
                      <div className="col-sm-6 col-md-4 mb-3">
                        <label className="form-label">
                          Secondary Member Id <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="alternate_member_id"
                          value={formData?.alternate_member_id}
                          onChange={handleChange}
                        />
                        {errors.alternate_member_id && (
                          <span className="text-danger fs-12">
                            {errors.alternate_member_id}
                          </span>
                        )}
                      </div>
                  }

                  {formData?.user_type == "ICAI" && (
                    <div className="col-sm-6 col-md-4">
                      <label className="col-form-label">
                        Zone <span className="text-danger">*</span>
                      </label>
                      <Select
                        className="w-100"
                        value={selectedZoneOption}
                        onChange={(option) => {
                          setSelectedZoneOption(option);
                          setFormData({
                            ...formData,
                            zone: option.value,
                          });
                        }}
                        defaultValue={selectedZoneOption}
                        options={zoneOption}
                        style={{
                          lineHeight: "40px",
                          color: "#7e7e7e",
                          paddingLeft: " 15px",
                        }}
                      />
                      {errors.zone && (
                        <span className="text-danger fs-12">{errors.zone}</span>
                      )}
                    </div>
                  )}

                  <div className="col-sm-6 col-md-4 mb-3">
                    <label className="form-label">Industry</label>
                    <input
                      className="form-control"
                      type="text"
                      name="industry"
                      maxLength={50}
                      value={formData?.industry}
                      onChange={handleChange}
                    />
                    {errors.industry && (
                      <span className="text-danger fs-12">
                        {errors.industry}
                      </span>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 mb-3">
                    <label className="form-label">Company Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="company_name"
                      maxLength={50}
                      value={formData?.company_name}
                      onChange={handleChange}
                    />
                    {errors.company_name && (
                      <span className="text-danger fs-12">
                        {errors.company_name}
                      </span>
                    )}
                  </div>


                  <div className="col-sm-6 col-md-4 mb-3">
                    <label className="form-label">Designation</label>
                    <input
                      className="form-control"
                      type="text"
                      name="designation"
                      maxLength={50}
                      value={formData?.designation}
                      onChange={handleChange}
                    />
                    {errors.designation && (
                      <span className="text-danger fs-12">
                        {errors.designation}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 mb-3">
                    <label className="form-label">State</label>
                    <input
                      className="form-control"
                      name="state"
                      value={formData?.state}
                      onChange={handleChange}
                    />
                    {errors.state && (
                      <span className="text-danger fs-12">
                        {errors.state}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 mb-3">
                    <label className="form-label">City</label>
                    <input
                      className="form-control"
                      name="city"
                      value={formData?.city}
                      onChange={handleChange}
                    />
                    {errors.city && (
                      <span className="text-danger fs-12">
                        {errors.city}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      name="google_address"
                      value={formData?.google_address}
                      onChange={handleChange}
                      rows="4"
                      cols="50"></textarea>
                    {/* <input
                      className="form-control"
                      name="google_address"
                      value={formData?.google_address}
                      onChange={handleChange}
                    /> */}
                    {errors.google_address && (
                      <span className="text-danger fs-12">
                        {errors.google_address}
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card profile-card card-bx ">
              <div className="card-header">
                <h6 className="card-title">Contact Info </h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">
                      Phone <span className="text-danger">*</span>
                    </label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}
                      value={formData?.mobile}
                      onChange={handlePhoneNoChange}
                    />
                    {errors.mobile && (
                      <span className="text-danger fs-12">{errors.mobile}</span>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">WhatsApp No</label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}
                      value={formData?.whatsapp_number}
                      onChange={handleWhatsappNoChange}
                    />
                    {errors.whatsapp_number && (
                      <span className="text-danger fs-12">
                        {errors.whatsapp_number}
                      </span>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">WhatsApp Business</label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}
                      value={formData?.whatsapp_business_number}
                      onChange={handleWhatsappBusinessNoChange}
                    />
                    {errors.whatsapp_business_number && (
                      <span className="text-danger fs-12">
                        {errors.whatsapp_business_number}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="card profile-card card-bx ">
              <div className="card-header">
                <h6 className="card-title">Account Info</h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">
                      Email{formData?.user_type == "Non-ICAI" && <span className="text-danger">*</span>}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      value={formData?.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <span className="text-danger fs-12">{errors.email}</span>
                    )}
                  </div>
                  {/* {formData?.user_type == "Non-ICAI" &&
                    <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                      <label className="col-form-label">Password <span className="text-danger">*</span></label>
                      <div className="input-group pass-group">
                        <input
                          placeholder="Password"
                          type={showPassword ? "text" : "password"}
                          className="form-control pass-input"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span className={`input-group-text pass-handle ${showPassword ? "active" : ""}`}
                          onClick={() => setShowPassword(!showPassword)}>
                          <i className="fa fa-eye-slash" />
                          <i className="fa fa-eye" />
                        </span>
                      </div>
                      {errors.password && <div className="text-danger fs-12">{errors.password}</div>}
                    </div>
                  } */}
                </div>
              </div>

              {formData?.user_type == "ICAI" &&
                <div className="card-footer align-items-center d-flex justify-content-end">
                  <button className="btn btn-primary">
                    {btnLoading && <BtnLoader />}
                    Submit
                  </button>

                </div>
              }
            </div>
          </div>

          {/* <div className="col-xl-12">
            <div className="card profile-card card-bx ">
              <div className="card-header">
                <h6 className="card-title">Social Media Info</h6>
              </div>
              <div className="card-body">
                <div className="row">

                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Website</label>
                    <input
                      className="form-control"
                      value={formData?.website}
                      onChange={handleChange}
                      name="website"
                    />
                    {errors.website && (
                      <span className="text-danger fs-12">
                        {errors.website}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Linkedin Profile Link</label>
                    <input
                      className="form-control"
                      value={formData?.linkedin_link}
                      onChange={handleChange}
                      name="linkedin_link"
                    />
                    {errors.linkedin_link && (
                      <span className="text-danger fs-12">
                        {errors.linkedin_link}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Youtube Channel</label>
                    <input
                      className="form-control"
                      value={formData?.youtube}
                      onChange={handleChange}
                      name="youtube"
                    />
                    {errors.youtube && (
                      <span className="text-danger fs-12">
                        {errors.youtube}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Instagram Profile Link</label>
                    <input
                      className="form-control"
                      name="instagram_link"
                      value={formData?.instagram_link}
                      onChange={handleChange}
                    />
                    {errors.instagram_link && (
                      <span className="text-danger fs-12">
                        {errors.instagram_link}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Facebook Profile Link</label>
                    <input
                      className="form-control"
                      name="facebook_link"
                      value={formData?.facebook_link}
                      onChange={handleChange}
                    />
                    {errors.facebook_link && (
                      <span className="text-danger fs-12">
                        {errors.facebook_link}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Twitter Profile Link</label>
                    <input
                      className="form-control"
                      name="twitter_link"
                      value={formData?.twitter_link}
                      onChange={handleChange}
                    />
                    {errors.twitter_link && (
                      <span className="text-danger fs-12">
                        {errors.twitter_link}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Snapchat Profile Link</label>
                    <input
                      className="form-control"
                      name="snapchat_link"
                      value={formData?.snapchat_link}
                      onChange={handleChange}
                    />
                    {errors.snapchat_link && (
                      <span className="text-danger fs-12">
                        {errors.snapchat_link}
                      </span>
                    )}
                  </div>

                  <div className="d-flex flex-column col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Skype Id</label>
                    <input
                      className="form-control"
                      name="skype_id"
                      value={formData?.skype_id}
                      onChange={handleChange}
                    />
                    {errors.skype_id && (
                      <span className="text-danger fs-12">
                        {errors.skype_id}
                      </span>
                    )}
                  </div>

                  <div className="col-sm-6 col-md-4 col-md-4 mb-3">
                    <label className="form-label">Telegram</label>
                    <input
                      className="form-control"
                      type="text"
                      name="telegram_link"
                      value={formData?.telegram_link}
                      onChange={handleChange}
                    />
                    {errors.telegram_link && (
                      <span className="text-danger fs-12">
                        {errors.telegram_link}
                      </span>
                    )}
                  </div>
                  <div className="card-footer align-items-center d-flex justify-content-end">
                    <button className="btn btn-primary">
                      {btnLoading && <BtnLoader />}
                      Submit
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {formData?.user_type == "Non-ICAI" &&
            <>
              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header Recommended-header">
                    <h6 className="card-title all-headers-color">Recommended</h6>

                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={websiteImg} alt="website" height={32} />
                            Website</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.website.name}
                              onChange={(e) => handleRecommendedChange(e, "website", "name")}
                              placeholder="Website"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.website.url}
                              onChange={(e) => handleRecommendedChange(e, "website", "url")}
                              placeholder="URL"
                            />
                          </div>

                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={catalogueImg} alt="catalogue" height={32} />
                            Catalogue</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.catalogue.name}
                              onChange={(e) => handleRecommendedChange(e, "catalogue", "name")}
                              placeholder="Catalogue"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.catalogue.url}
                              onChange={(e) => handleRecommendedChange(e, "catalogue", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>



                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={instagramImg} alt="phone" height={32} />
                            Instagram</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.instagram.name}
                              onChange={(e) => handleRecommendedChange(e, "instagram", "name")}
                              placeholder="Instagram"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.instagram.url}
                              onChange={(e) => handleRecommendedChange(e, "instagram", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={linkedinImg} alt="phone" height={32} />
                            Linkedin</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.linkedin.name}
                              onChange={(e) => handleRecommendedChange(e, "linkedin", "name")}
                              placeholder="Linkedin"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.linkedin.url}
                              onChange={(e) => handleRecommendedChange(e, "linkedin", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={emailImg} alt="catalogue" height={32} />
                          Email</label>


                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.email.name}
                            onChange={(e) => handleRecommendedChange(e, "email", "name")}
                            placeholder="Email"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.email.url}
                            onChange={(e) => handleRecommendedChange(e, "email", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      {/* 
                    <div className="col-md-3 mb-3">

                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={whatsAppImg} alt="whatsApp" height={32} />
                          WhatsApp</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.whatsApp.name}
                            onChange={(e) => handleRecommendedChange(e, "whatsApp", "name")}
                            placeholder="WhatsApp"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.whatsApp.url}
                            onChange={(e) => handleRecommendedChange(e, "whatsApp", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>

                    </div> */}
                    </div>
                    <div className="row mb-3">
                      {/* <div className="col-md-3 mb-3">

                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={phoneImg} alt="phone" height={32} />
                          Phone</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.phone.name}
                            onChange={(e) => handleRecommendedChange(e, "phone", "name")}
                            placeholder="Phone"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.phone.url}
                            onChange={(e) => handleRecommendedChange(e, "phone", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>

                    </div> */}
                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={googleRatingImg} height={32} />
                            Google Reviews</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.google_reviews.name}
                              onChange={(e) => handleRecommendedChange(e, "google_reviews", "name")}
                              placeholder="Google Reviews"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.google_reviews.url}
                              onChange={(e) => handleRecommendedChange(e, "google_reviews", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-md-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={instagramImg} alt="phone" height={32} />
                          Instagram</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.instagram.name}
                            onChange={(e) => handleRecommendedChange(e, "instagram", "name")}
                            placeholder="Instagram"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.instagram.url}
                            onChange={(e) => handleRecommendedChange(e, "instagram", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">

                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={linkedinImg} alt="phone" height={32} />
                          Linkedin</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.linkedin.name}
                            onChange={(e) => handleRecommendedChange(e, "linkedin", "name")}
                            placeholder="Linkedin"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.linkedin.url}
                            onChange={(e) => handleRecommendedChange(e, "linkedin", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={youtubeImg} alt="phone" height={32} />
                            Youtube</label>


                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.youtube.name}
                              onChange={(e) => handleRecommendedChange(e, "youtube", "name")}
                              placeholder="Youtube"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.youtube.url}
                              onChange={(e) => handleRecommendedChange(e, "youtube", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                    </div>

                    {/* <div className="row mb-3" >
                    <div className="col-md-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={youtubeImg} alt="phone" height={32} />
                          Youtube</label>


                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.youtube.name}
                            onChange={(e) => handleRecommendedChange(e, "youtube", "name")}
                            placeholder="Youtube"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={recommendedData.youtube.url}
                            onChange={(e) => handleRecommendedChange(e, "youtube", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}


                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header contact-header">
                    <h6 className="card-title all-headers-color">Contact Info</h6>

                  </div>
                  <div className="card-body">
                    {/* <div className="row mb-3">
                    <div className="col-sm-3 mb-3">

                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={emailImg} alt="catalogue" height={32} />
                          Email</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.email.name}
                            onChange={(e) => handleContactChange(e, "email", "name")}
                            placeholder="Email"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.email.url}
                            onChange={(e) => handleContactChange(e, "email", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>

                    </div>

                    <div className="col-sm-3 mb-3">

                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={whatsAppImg} alt="whatsApp" height={32} />
                          WhatsApp</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.whatsApp.name}
                            onChange={(e) => handleContactChange(e, "whatsApp", "name")}
                            placeholder="WhatsApp"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.whatsApp.url}
                            onChange={(e) => handleContactChange(e, "whatsApp", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={phoneImg} alt="phone" height={32} />
                          Phone</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.phone.name}
                            onChange={(e) => handleContactChange(e, "phone", "name")}
                            placeholder="Phone"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.phone.url}
                            onChange={(e) => handleContactChange(e, "phone", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={messageImg} alt="message" height={32} />
                          Message</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.message.name}
                            onChange={(e) => handleContactChange(e, "message", "name")}
                            placeholder="Message"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={contactData.message.url}
                            onChange={(e) => handleContactChange(e, "message", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>

                    </div>
                  </div> */}


                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={facetimeImg} height={32} />
                            Facetime</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.facetime.name}
                              onChange={(e) => handleContactChange(e, "facetime", "name")}
                              placeholder="Facetime"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.facetime.url}
                              onChange={(e) => handleContactChange(e, "facetime", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={wechatImg} alt="weChat" height={32} />
                            WeChat</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.wechat.name}
                              onChange={(e) => handleContactChange(e, "wechat", "name")}
                              placeholder="WeChat"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.wechat.url}
                              onChange={(e) => handleContactChange(e, "wechat", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={skypeImg} alt="skype" height={32} />
                            Skype</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.skype.name}
                              onChange={(e) => handleContactChange(e, "skype", "name")}
                              placeholder="Skype"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.skype.url}
                              onChange={(e) => handleContactChange(e, "skype", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>

                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={messageImg} alt="message" height={32} />
                            Message</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.message.name}
                              onChange={(e) => handleContactChange(e, "message", "name")}
                              placeholder="Message"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.message.url}
                              onChange={(e) => handleContactChange(e, "message", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={kakaotalkImg} alt="kakaotalk" height={32} />
                            KakaoTalk</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.kakaotalk.name}
                              onChange={(e) => handleContactChange(e, "kakaotalk", "name")}
                              placeholder="KakaoTalk"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.kakaotalk.url}
                              onChange={(e) => handleContactChange(e, "kakaotalk", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header business-info-header">
                    <h6 className="card-title all-headers-color">Business Info</h6>

                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">

                        {/* <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={websiteImg} alt="website" height={32} />
                          Website</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.website.name}
                            onChange={(e) => handlebusinessInfoChange(e, "website", "name")}
                            placeholder="Website"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.website.url}
                            onChange={(e) => handlebusinessInfoChange(e, "website", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div> */}

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={websiteImg} alt="website" height={32} />
                            Website</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.website.name}
                              onChange={(e) => handleRecommendedChange(e, "website", "name")}
                              placeholder="Website"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.website.url}
                              onChange={(e) => handleRecommendedChange(e, "website", "url")}
                              placeholder="URL"
                            />
                          </div>

                        </div>

                      </div>

                      {/* <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={catalogueImg} alt="catalogue" height={32} />
                          Catalogue</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.catalogue.name}
                            onChange={(e) => handlebusinessInfoChange(e, "catalogue", "name")}
                            placeholder="Catalogue"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.catalogue.url}
                            onChange={(e) => handlebusinessInfoChange(e, "catalogue", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={catalogueImg} alt="catalogue" height={32} />
                            Catalogue</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.catalogue.name}
                              onChange={(e) => handleRecommendedChange(e, "catalogue", "name")}
                              placeholder="Catalogue"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.catalogue.url}
                              onChange={(e) => handleRecommendedChange(e, "catalogue", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={locationImg} alt="location" height={32} />
                            Location</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.location.name}
                              onChange={(e) => handlebusinessInfoChange(e, "location", "name")}
                              placeholder="Location"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.location.url}
                              onChange={(e) => handlebusinessInfoChange(e, "location", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>

                      {/* <div className="col-md-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={messageImg} alt="message" height={32} />
                          Message</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.message.name}
                            onChange={(e) => handlebusinessInfoChange(e, "message", "name")}
                            placeholder="Message"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.message.url}
                            onChange={(e) => handlebusinessInfoChange(e, "message", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={messageImg} alt="message" height={32} />
                            Message</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.message.name}
                              onChange={(e) => handleContactChange(e, "message", "name")}
                              placeholder="Message"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contactData.message.url}
                              onChange={(e) => handleContactChange(e, "message", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>


                    </div>


                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={phoneImg} height={32} />
                            Business Phone</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.business_phone.name}
                              onChange={(e) => handlebusinessInfoChange(e, "business_phone", "name")}
                              placeholder="Business Phone"
                            />
                          </div>

                          <div>
                            {/* <input
                            className="form-control"
                            type="text"
                            value={businessInfoData.business_phone.url}
                            onChange={(e) => handlebusinessInfoChange(e, "business_phone", "url")}
                            placeholder="Business Phone No."
                          /> */}
                            <PhoneInput
                              className=""
                              inputClass=""
                              country={"in"}
                              value={businessInfoData.business_phone.url}
                              onChange={handleBusinessPhoneChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={emailImg} height={32} />
                            Business Email</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.business_email.name}
                              onChange={(e) => handlebusinessInfoChange(e, "business_email", "name")}
                              placeholder="Business Email"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="email"
                              value={businessInfoData.business_email.url}
                              onChange={(e) => handlebusinessInfoChange(e, "business_email", "url")}
                              placeholder="Email"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={calendyImg} height={32} />
                            Calendly</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.calendly.name}
                              onChange={(e) => handlebusinessInfoChange(e, "calendly", "name")}
                              placeholder="Calendly"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={businessInfoData.calendly.url}
                              onChange={(e) => handlebusinessInfoChange(e, "calendly", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header social-media-header">
                    <h6 className="card-title all-headers-color">Social Media</h6>

                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={ticktokImg} height={32} />
                            Tiktok</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.tiktok.name}
                              onChange={(e) => handleSocialMediaChange(e, "tiktok", "name")}
                              placeholder="Tiktok"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.tiktok.url}
                              onChange={(e) => handleSocialMediaChange(e, "tiktok", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={instagramImg} height={32} />
                          Instagram</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.instagram.name}
                            onChange={(e) => handleSocialMediaChange(e, "instagram", "name")}
                            placeholder="Instagram"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.instagram.url}
                            onChange={(e) => handleSocialMediaChange(e, "instagram", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={instagramImg} alt="phone" height={32} />
                            Instagram</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.instagram.name}
                              onChange={(e) => handleRecommendedChange(e, "instagram", "name")}
                              placeholder="Instagram"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.instagram.url}
                              onChange={(e) => handleRecommendedChange(e, "instagram", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>


                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={facebookImg} height={32} />
                            Facebook</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.facebook.name}
                              onChange={(e) => handleSocialMediaChange(e, "facebook", "name")}
                              placeholder="Facebook"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.facebook.url}
                              onChange={(e) => handleSocialMediaChange(e, "facebook", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-md-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={linkedinImg} height={32} />
                          Linkedin</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.linkedin.name}
                            onChange={(e) => handleSocialMediaChange(e, "linkedin", "name")}
                            placeholder="Linkedin"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.linkedin.url}
                            onChange={(e) => handleSocialMediaChange(e, "linkedin", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}

                      <div className="col-md-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={linkedinImg} alt="phone" height={32} />
                            Linkedin</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.linkedin.name}
                              onChange={(e) => handleRecommendedChange(e, "linkedin", "name")}
                              placeholder="Linkedin"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.linkedin.url}
                              onChange={(e) => handleRecommendedChange(e, "linkedin", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={snapchatImg} height={32} />
                            Snapchat</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.snapchat.name}
                              onChange={(e) => handleSocialMediaChange(e, "snapchat", "name")}
                              placeholder="Snapchat"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.snapchat.url}
                              onChange={(e) => handleSocialMediaChange(e, "snapchat", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={youtubeImg} height={32} />
                          Youtube</label>
                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.youtube.name}
                            onChange={(e) => handleSocialMediaChange(e, "youtube", "name")}
                            placeholder="Youtube"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={socialMediaData.youtube.url}
                            onChange={(e) => handleSocialMediaChange(e, "youtube", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}

                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={youtubeImg} alt="phone" height={32} />
                            Youtube</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.youtube.name}
                              onChange={(e) => handleRecommendedChange(e, "youtube", "name")}
                              placeholder="Youtube"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.youtube.url}
                              onChange={(e) => handleRecommendedChange(e, "youtube", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={twitterImg} height={32} />
                            Twitter</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.twitter.name}
                              onChange={(e) => handleSocialMediaChange(e, "twitter", "name")}
                              placeholder="Twitter"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.twitter.url}
                              onChange={(e) => handleSocialMediaChange(e, "twitter", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={pintrestImg} height={32} />
                            Pinterest</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.pinterest.name}
                              onChange={(e) => handleSocialMediaChange(e, "pinterest", "name")}
                              placeholder="Pinterest"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.pinterest.url}
                              onChange={(e) => handleSocialMediaChange(e, "pinterest", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={twitchImg} height={32} />
                            Twitch</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.twitch.name}
                              onChange={(e) => handleSocialMediaChange(e, "twitch", "name")}
                              placeholder="Twitch"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.twitch.url}
                              onChange={(e) => handleSocialMediaChange(e, "twitch", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={telegramImg} height={32} />
                            Telegram</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.telegram.name}
                              onChange={(e) => handleSocialMediaChange(e, "telegram", "name")}
                              placeholder="Telegram"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={socialMediaData.telegram.url}
                              onChange={(e) => handleSocialMediaChange(e, "telegram", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header reviews-header">
                    <h6 className="card-title all-headers-color">Reviews</h6>

                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      {/* <div className="col-sm-3 mb-3">
                      <div>
                        <label className="form-label d-flex align-items-center gap-1">
                          <img src={googleRatingImg} height={32} />
                          Google Reviews</label>

                        <div className="mb-2">
                          <input
                            className="form-control"
                            type="text"
                            value={reviewsData.google_reviews.name}
                            onChange={(e) => handleReviewsChange(e, "google_reviews", "name")}
                            placeholder="Google Reviews"
                          />
                        </div>

                        <div>
                          <input
                            className="form-control"
                            type="text"
                            value={reviewsData.google_reviews.url}
                            onChange={(e) => handleReviewsChange(e, "google_reviews", "url")}
                            placeholder="URL"
                          />
                        </div>
                      </div>
                    </div> */}
                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={googleRatingImg} alt="phone" height={32} />
                            Google Reviews</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.google_reviews.name}
                              onChange={(e) => handleRecommendedChange(e, "google_reviews", "name")}
                              placeholder="Google Reviews"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={recommendedData.google_reviews.url}
                              onChange={(e) => handleRecommendedChange(e, "google_reviews", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={trustpilotImg} height={32} />
                            Trustpilot</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.trustpilot.name}
                              onChange={(e) => handleReviewsChange(e, "trustpilot", "name")}
                              placeholder="Trustpilot"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.trustpilot.url}
                              onChange={(e) => handleReviewsChange(e, "trustpilot", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={bookingImg} height={32} />
                            Booking</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.booking.name}
                              onChange={(e) => handleReviewsChange(e, "booking", "name")}
                              placeholder="Booking"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.booking.url}
                              onChange={(e) => handleReviewsChange(e, "booking", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={tripadvisorImg} height={32} />
                            Tripadvisor</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.tripadvisor.name}
                              onChange={(e) => handleReviewsChange(e, "tripadvisor", "name")}
                              placeholder="Tripadvisor"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.tripadvisor.url}
                              onChange={(e) => handleReviewsChange(e, "tripadvisor", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="row">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={makemytripImg} height={32} />
                            Make My trip</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="make_my_trip"
                              value={reviewsData.make_my_trip.name}
                              onChange={(e) => handleReviewsChange(e, "make_my_trip", "name")}
                              placeholder="Make My trip"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.make_my_trip.url}
                              onChange={(e) => handleReviewsChange(e, "make_my_trip", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={goibiboImg} height={32} />
                            Goibibo</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.goibibo.name}
                              onChange={(e) => handleReviewsChange(e, "goibibo", "name")}
                              placeholder="Goibibo"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={reviewsData.goibibo.url}
                              onChange={(e) => handleReviewsChange(e, "goibibo", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>


              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header content-header">
                    <h6 className="card-title all-headers-color">Content</h6>

                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={pdfImg} height={32} />
                            PDF</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.pdf.name}
                              onChange={(e) => handleContentChange(e, "pdf", "name")}
                              placeholder="PDF"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.pdf.url}
                              onChange={(e) => handleContentChange(e, "pdf", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={videoImg} height={32} />
                            Video</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.video.name}
                              onChange={(e) => handleContentChange(e, "video", "name")}
                              placeholder="Video"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.video.url}
                              onChange={(e) => handleContentChange(e, "video", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={imageImg} height={32} />
                            Image</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.image.name}
                              onChange={(e) => handleContentChange(e, "image", "name")}
                              placeholder="Image"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={contentData.image.url}
                              onChange={(e) => handleContentChange(e, "image", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header food-header">
                    <h6 className="card-title all-headers-color">Food</h6>

                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={zomatoImg} height={32} />
                            Zomato</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.zomato.name}
                              onChange={(e) => handleFoodChange(e, "zomato", "name")}
                              placeholder="Zomato"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.zomato.url}
                              onChange={(e) => handleFoodChange(e, "zomato", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={swiggyImg} height={32} />
                            Swiggy</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.swiggy.name}
                              onChange={(e) => handleFoodChange(e, "swiggy", "name")}
                              placeholder="Swiggy"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.swiggy.url}
                              onChange={(e) => handleFoodChange(e, "swiggy", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={ubereatsImg} height={32} />
                            Uber Eats</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.uber_eats.name}
                              onChange={(e) => handleFoodChange(e, "uber_eats", "name")}
                              placeholder="Uber Eats"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.uber_eats.url}
                              onChange={(e) => handleFoodChange(e, "uber_eats", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={eatclubImg} height={32} />
                            EatClub</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.eatclub.name}
                              onChange={(e) => handleFoodChange(e, "eatclub", "name")}
                              placeholder="EatClub"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.eatclub.url}
                              onChange={(e) => handleFoodChange(e, "eatclub", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={menuImg} height={32} />
                            Menu</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.menu.name}
                              onChange={(e) => handleFoodChange(e, "menu", "name")}
                              placeholder="Menu"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={foodData.menu.url}
                              onChange={(e) => handleFoodChange(e, "menu", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header communication-groups-header">
                    <h6 className="card-title all-headers-color">Communication Groups</h6>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={slackImg} height={32} />
                            Slack</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.slack.name}
                              onChange={(e) => handleCommunicationChange(e, "slack", "name")}
                              placeholder="Slack"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.slack.url}
                              onChange={(e) => handleCommunicationChange(e, "slack", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={whatsAppImg} height={32} />
                            WhatsApp Group</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.whatsapp_group.name}
                              onChange={(e) => handleCommunicationChange(e, "whatsapp_group", "name")}
                              placeholder="WhatsApp Group"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.whatsapp_group.url}
                              onChange={(e) => handleCommunicationChange(e, "whatsapp_group", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={facebookImg} height={32} />
                            Facebook Group</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.facebook_group.name}
                              onChange={(e) => handleCommunicationChange(e, "facebook_group", "name")}
                              placeholder="Facebook Group"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={communicationData.facebook_group.url}
                              onChange={(e) => handleCommunicationChange(e, "facebook_group", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header music-header">
                    <h6 className="card-title all-headers-color">Music</h6>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={spotifyImg} height={32} />
                            Spotify</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={musicData.spotify.name}
                              onChange={(e) => handleMusicChange(e, "spotify", "name")}
                              placeholder="Spotify"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={musicData.spotify.url}
                              onChange={(e) => handleMusicChange(e, "spotify", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header shopping-header">
                    <h6 className="card-title all-headers-color">Shopping</h6>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={amazonImg} height={32} />
                            Amazon</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.amazon.name}
                              onChange={(e) => handleShoppingChange(e, "amazon", "name")}
                              placeholder="Amazon"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.amazon.url}
                              onChange={(e) => handleShoppingChange(e, "amazon", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={flipkartImg} height={32} />
                            Flipkart</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.flipkart.name}
                              onChange={(e) => handleShoppingChange(e, "flipkart", "name")}
                              placeholder="Flipkart"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.flipkart.url}
                              onChange={(e) => handleShoppingChange(e, "flipkart", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={myntraImg} height={32} />
                            Myntra</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.myntra.name}
                              onChange={(e) => handleShoppingChange(e, "myntra", "name")}
                              placeholder="Myntra"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={shoppingData.myntra.url}
                              onChange={(e) => handleShoppingChange(e, "myntra", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header event-header">
                    <h6 className="card-title all-headers-color">Event</h6>
                  </div>

                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={meetupImg} height={32} />
                            MeetUp</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.meetup.name}
                              onChange={(e) => handleEventChange(e, "meetup", "name")}
                              placeholder="MeetUp"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.meetup.url}
                              onChange={(e) => handleEventChange(e, "meetup", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={humanitixImg} height={32} />
                            Humanitix</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.humanitix.name}
                              onChange={(e) => handleEventChange(e, "humanitix", "name")}
                              placeholder="Humanitix"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.humanitix.url}
                              onChange={(e) => handleEventChange(e, "humanitix", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={ticketmasterImg} height={32} />
                            Ticketmaster</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.ticketmaster.name}
                              onChange={(e) => handleEventChange(e, "ticketmaster", "name")}
                              placeholder="Ticketmaster"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.ticketmaster.url}
                              onChange={(e) => handleEventChange(e, "ticketmaster", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={lumaImg} height={32} />
                            Luma</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.luma.name}
                              onChange={(e) => handleEventChange(e, "luma", "name")}
                              placeholder="Luma"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.luma.url}
                              onChange={(e) => handleEventChange(e, "luma", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={sortmysceneImg} height={32} />
                            Sort My Scene</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.sort_my_scene.name}
                              onChange={(e) => handleEventChange(e, "sort_my_scene", "name")}
                              placeholder="Sort My Scene"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.sort_my_scene.url}
                              onChange={(e) => handleEventChange(e, "sort_my_scene", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>

                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={paytminsiderImg} height={32} />
                            Paytm Insider</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.paytm_insider.name}
                              onChange={(e) => handleEventChange(e, "paytm_insider", "name")}
                              placeholder="Paytm Insider"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.paytm_insider.url}
                              onChange={(e) => handleEventChange(e, "paytm_insider", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={bookmyshowImg} height={32} />
                            BookMyShow</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.book_my_show.name}
                              onChange={(e) => handleEventChange(e, "book_my_show", "name")}
                              placeholder="BookMyShow"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={eventData.book_my_show.url}
                              onChange={(e) => handleEventChange(e, "book_my_show", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header payments-header">
                    <h6 className="card-title all-headers-color">Payments</h6>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={stripeImg} height={32} />
                            Stripe</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.stripe.name}
                              onChange={(e) => handlePaymentsChange(e, "stripe", "name")}
                              placeholder="Stripe"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.stripe.url}
                              onChange={(e) => handlePaymentsChange(e, "stripe", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={paypalImg} height={32} />
                            PayPal</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.paypal.name}
                              onChange={(e) => handlePaymentsChange(e, "paypal", "name")}
                              placeholder="PayPal"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.paypal.url}
                              onChange={(e) => handlePaymentsChange(e, "paypal", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={cryptowalletImg} height={32} />
                            Crypto Wallet</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.crypto_wallet.name}
                              onChange={(e) => handlePaymentsChange(e, "crypto_wallet", "name")}
                              placeholder="Crypto Wallet"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={paymentsData.crypto_wallet.url}
                              onChange={(e) => handlePaymentsChange(e, "crypto_wallet", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-8">
                <div className="card profile-card card-bx">
                  <div className="card-header more-header">
                    <h6 className="card-title all-headers-color">More</h6>
                  </div>

                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={mediumImg} height={32} />
                            Medium</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.medium.name}
                              onChange={(e) => handleMoreChange(e, "medium", "name")}
                              placeholder="Medium"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.medium.url}
                              onChange={(e) => handleMoreChange(e, "medium", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={appstoreImg} height={32} />
                            App Store</label>

                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.app_store.name}
                              onChange={(e) => handleMoreChange(e, "app_store", "name")}
                              placeholder="App Store"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.app_store.url}
                              onChange={(e) => handleMoreChange(e, "app_store", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={playstoreImg} height={32} />
                            PlayStore</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.play_store.name}
                              onChange={(e) => handleMoreChange(e, "play_store", "name")}
                              placeholder="PlayStore"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.play_store.url}
                              onChange={(e) => handleMoreChange(e, "play_store", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">

                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={discordImg} height={32} />
                            Discord</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.discord.name}
                              onChange={(e) => handleMoreChange(e, "discord", "name")}
                              placeholder="Discord"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.discord.url}
                              onChange={(e) => handleMoreChange(e, "discord", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={onlyfansImg} height={32} />
                            Only Fans</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.only_fans.name}
                              onChange={(e) => handleMoreChange(e, "only_fans", "name")}
                              placeholder="Only Fans"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.only_fans.url}
                              onChange={(e) => handleMoreChange(e, "only_fans", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>
                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={behanceImg} height={32} />
                            Behance</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.behance.name}
                              onChange={(e) => handleMoreChange(e, "behance", "name")}
                              placeholder="Behance"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.behance.url}
                              onChange={(e) => handleMoreChange(e, "behance", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-3">
                        <div>

                          <label className="form-label d-flex align-items-center gap-1">
                            <img src={openseaImg} height={32} />
                            Open Sea</label>
                          <div className="mb-2">
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.open_sea.name}
                              onChange={(e) => handleMoreChange(e, "open_sea", "name")}
                              placeholder="Open Sea"
                            />
                          </div>

                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={moreData.open_sea.url}
                              onChange={(e) => handleMoreChange(e, "open_sea", "url")}
                              placeholder="URL"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer align-items-center d-flex justify-content-end py-4">
                    <button className="btn btn-primary" type="submit">
                      {btnLoading && <BtnLoader />}
                      Submit
                    </button>

                  </div>

                </div>
              </div>
            </>}

        </div>
      </form>
    </>
  );
};
export default EditUser;
